import {useSequenceValidation} from '@/modules/patients-therapies/hooks'
import {Box, Button, Text} from '@chakra-ui/react'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {useTranslate} from '@tolgee/react'
import {ValidatedLine} from './validated-line'

// Validation summary and removal for already-validated prescriptions in the
// prescription pop-up: pharmacy-validated sequences clear the pharmacist's
// validation, doctor-validated ones the doctor's.
export function ValidationSummary({sequence}: {sequence: PatientTherapySequence}) {
  const {t} = useTranslate('common')
  const {onRemoveValidation, canRemoveValidation, removeValidationLabel, doctorValidator, pharmacistValidator} =
    useSequenceValidation(sequence)

  const removesPharmacistValidation = Boolean(sequence.pharmacistValidatedAt)
  const heading = removesPharmacistValidation ? t('doctor_and_pharmacist_validated') : t('doctor_validated')

  return (
    <Box spaceY="2" width="100%">
      <Text color="green.fg" fontSize="sm" fontWeight="medium">
        {heading}
      </Text>

      {removesPharmacistValidation ? (
        <>
          <ValidatedLine label={t('doctor_validated')} name={doctorValidator?.name} time={sequence.doctorValidatedAt} />
          <ValidatedLine
            label={t('pharmacist_validated')}
            name={pharmacistValidator?.name}
            time={sequence.pharmacistValidatedAt}
          />
        </>
      ) : (
        <ValidatedLine label={null} name={doctorValidator?.name} time={sequence.doctorValidatedAt} />
      )}

      <Button
        width="100%"
        variant="subtle"
        colorPalette="cyan"
        disabled={!canRemoveValidation()}
        onClick={onRemoveValidation}
      >
        {removeValidationLabel}
      </Button>
    </Box>
  )
}
